<template>
  <div  class="text-center" >
    <div v-if="params.value">
<b-icon icon="check-circle-fill" font-scale="2" variant="success" ></b-icon>

    </div>
    <div v-else>
      -

    </div>
    <!-- {{ params.value }} -->
  </div>
</template>

<script>
export default {
  mounted() {
    // console.log("params", this.params);
  },
  methods: {}
};
</script>
